export default __webpack_public_path__ + "static/media/Boots of the Rippling Lake.bb8bc158.jpg";